import { render, staticRenderFns } from "./user-coach-history.vue?vue&type=template&id=43e38013&"
import script from "./user-coach-history.vue?vue&type=script&lang=js&"
export * from "./user-coach-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports